<template>
  <v-container id="testimonials" tag="section" class="mb-4">
    <base-subheading removeBottomSpacing>Testimonials</base-subheading>

    <v-carousel
      cycle
      class="mt-n2"
      height="350"
      hide-delimiter-background
      show-arrows-on-hover
      light
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        reverse-transition="fade-transition"
        transition="fade-transition"
      >
        <v-sheet height="100%">
          <v-row class="fill-height" align="center" justify="center">
            <v-card
              flat
              :width="$vuetify.breakpoint.smAndDown ? '90%' : '100%'"
            >
              <v-card-text
                class="text-center"
                :class="{
                  'text-h5': $vuetify.breakpoint.mdAndUp,
                  'text-body-1': $vuetify.breakpoint.smAndDown,
                }"
              >
                <v-icon
                  :class="{
                    'mb-4': $vuetify.breakpoint.mdAndUp,
                  }"
                  >mdi-format-quote-open</v-icon
                >
                {{ item.quote }}
                <v-icon
                  :class="{
                    'mb-4': $vuetify.breakpoint.mdAndUp,
                  }"
                  >mdi-format-quote-close</v-icon
                >
              </v-card-text>
              <v-card-text class="text-center">
                <v-rating
                  background-color="orange lighten-3"
                  color="orange"
                  length="5"
                  :value="item.stars"
                  :large="$vuetify.breakpoint.mdAndUp"
                ></v-rating>
              </v-card-text>
              <v-card-text
                class="text-center"
                :class="{
                  'mb-2': $vuetify.breakpoint.smAndDown,
                }"
                >{{ item.author }}</v-card-text
              >
            </v-card>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
export default {
  name: "Testimonials",
  data() {
    return {
      items: [
        {
          quote:
            "Just got my 2023 turkey back last month. Looks amazing. Top notch work and kept me updated through the process. I'll definitely be bringing more Turkey's and other birds here. 5 stars.",
          stars: 5,
          author: "Andy Porter",
        },
        {
          quote:
            "Does an amazing job of bringing your bird back to the form you shot it in. Every detail was outstanding!!",
          stars: 5,
          author: "Kolton Armstrong",
        },
        {
          quote:
            "If you want exceptional work done, look no further. Process was quick and simple. Best part, Aaron answers the phone! Highly Recommend!",
          stars: 5,
          author: "Ethan Price Outdoors",
        },
        {
          quote:
            "First time taking birds here very impressed an happy with his work will definitely take him more for sure! Very prompt on wait time he said 6 months a got them back to the very day if not sooner! Thank you very much!",
          stars: 5,
          author: "Kendall Zeigler",
        },
        {
          quote:
            "Aaron did an amazing job with my Woodie and even got it done early, highly recommended",
          stars: 5,
          author: "Justin Berkes",
        },
        {
          quote: "Awesome place very detailed in the wood duck he did for me",
          stars: 5,
          author: "Mike Friend",
        },
      ],
    };
  },
};
</script>
